"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
function DefaultImgComponent(props) {
  var objectFit = props.objectFit,
    src = props.src,
    alt = props.alt,
    loading = props.loading,
    imgId = props.imgId,
    imgRef = props.imgRef;
  return react_1["default"].createElement("img", {
    className: (0, classnames_1["default"])('odc-figure-img', "object-".concat(objectFit)),
    src: src,
    alt: alt,
    loading: loading,
    id: imgId,
    ref: imgRef
  });
}
exports["default"] = DefaultImgComponent;